import '../scss/app.scss';
import initNeighborsMap from './neighbors-map';

// Fix overflow: hidden on #page for park-hotel-rooms template - multiple methods
const fixOverflowForStickyTemplate = () => {
  const body = document.body;
  
  // Проверяем класс шаблона
  if (!body.classList.contains('page-template-page-templatespark-hotel-rooms-php')) {
    return;
  }
  
  console.log('🔧 Fixing overflow for sticky sidebar template...');
  
  // Метод 1: Через inline стили
  const selectors = ['#page', '.site', '#content', '.site-content', '.entry-content', 'main', 'article.room'];
  selectors.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) {
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('overflow-x', 'visible', 'important');
      el.style.setProperty('overflow-y', 'visible', 'important');
    }
  });
  
  // Метод 2: Добавляем CSS через style tag с максимальным приоритетом
  const styleId = 'sticky-overflow-fix';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .page-template-page-templatespark-hotel-rooms-php #page,
      .page-template-page-templatespark-hotel-rooms-php .site,
      .page-template-page-templatespark-hotel-rooms-php #content,
      .page-template-page-templatespark-hotel-rooms-php .site-content,
      .page-template-page-templatespark-hotel-rooms-php .entry-content,
      .page-template-page-templatespark-hotel-rooms-php main,
      .page-template-page-templatespark-hotel-rooms-php article.room {
        overflow: visible !important;
        overflow-x: visible !important;
        overflow-y: visible !important;
      }
    `;
    document.head.appendChild(style);
    console.log('✓ Added CSS override for overflow');
  }
  
  console.log('✓ Overflow fix applied');
};

// Выполняем сразу
fixOverflowForStickyTemplate();

// Sticky header functionality for Elementor
const initStickyHeader = () => {
  const header = document.querySelector('.elementor-location-header .elementor-sticky');
  if (!header) {
    console.log('Elementor sticky header not found, retrying...');
    // Если элемент не найден, пробуем еще раз через 500ms
    setTimeout(initStickyHeader, 500);
    return;
  }

  console.log('Elementor sticky header found, initializing...');
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // Убираем класс только когда находимся в самом верху
    if (currentScrollY === 0) {
      header.classList.remove('headerup');
    } else {
      // В любом другом случае (скролл вверх или вниз, но не в самом верху) - добавляем класс
      header.classList.add('headerup');
    }

    lastScrollY = currentScrollY;
  };

  // Устанавливаем правильный класс при инициализации
  handleScroll();

  // Слушаем скролл с захватом (capture: true) для более высокого приоритета
  window.addEventListener('scroll', handleScroll, { passive: true, capture: true });
  
  // Также используем MutationObserver для отслеживания изменений классов
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Если кто-то удалил наш класс, а мы не в самом верху - возвращаем его
        if (!header.classList.contains('headerup') && window.scrollY > 0) {
          console.log('Class "headerup" was removed by another script, restoring...');
          header.classList.add('headerup');
        }
      }
    });
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['class']
  });
};

const ensureLoyaltyButtonForMenu = (menu) => {
  if (!menu || menu.querySelector('.loyalty-menu-item')) {
    return;
  }

  const listItem = document.createElement('li');
  listItem.className = 'menu-item loyalty-menu-item';

  const link = document.createElement('a');
  link.className = 'loyalty-menu-link';
  link.textContent = 'Программа лояльности';
  link.setAttribute('href', '/programma-loyalnosti/');

  listItem.appendChild(link);
  menu.appendChild(listItem);
};

const ensureLoyaltyButton = () => {
  const headerRoot = document.querySelector('.elementor-location-header');
  if (!headerRoot) {
    return;
  }

  const callWidget = Array.from(headerRoot.querySelectorAll('.elementor-widget-button')).find((widget) => {
    const control = widget.querySelector('a, button');
    return control && control.textContent.trim().toLowerCase() === 'позвонить';
  });

  if (!callWidget) {
    return;
  }

  if (!headerRoot.querySelector('.elementor-widget-button[data-loyalty-button="desktop"]')) {
    const loyaltyWidget = callWidget.cloneNode(true);
    loyaltyWidget.dataset.loyaltyButton = 'desktop';
    loyaltyWidget.classList.add('loyalty-button-widget');

    const loyaltyControl = loyaltyWidget.querySelector('a, button');
    if (loyaltyControl) {
      loyaltyControl.textContent = 'Программа лояльности';

      if (loyaltyControl.tagName.toLowerCase() === 'a') {
        loyaltyControl.setAttribute('href', '/programma-loyalnosti/');
        loyaltyControl.setAttribute('target', '_self');
      }
    }

    const parent = callWidget.parentNode;
    if (parent) {
      parent.insertBefore(loyaltyWidget, callWidget.nextSibling);
    }
  }

  const headerMenuContainer = headerRoot.querySelector('.eael-simple-menu-container');
  if (headerMenuContainer) {
    const targetDevice = headerMenuContainer.getAttribute('data-hamburger-device');
    if (targetDevice && targetDevice !== 'none') {
      const headerMenu = headerMenuContainer.querySelector('.eael-simple-menu');
      ensureLoyaltyButtonForMenu(headerMenu);
    }
  }
};

let loyaltyObserver = null;

const initLoyaltyParallax = (
  selector,
  {
    defaultSpeed = 0.18,
    defaultLimit = 140,
    defaultScale = 1.08,
    defaultTarget = 'img',
    minWidth = 1281,
  } = {},
) => {
  const mediaBlocks = Array.from(document.querySelectorAll(selector));
  if (!mediaBlocks.length) {
    return;
  }

  let ticking = false;
  let enabled = false;

  const update = () => {
    if (!enabled) {
      ticking = false;
      return;
    }

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    mediaBlocks.forEach((block) => {
      const targetSelector = block.dataset.parallaxTarget || defaultTarget;
      const target =
        targetSelector === 'self' ? block : block.querySelector(targetSelector) || block.querySelector('img');

      if (!target) {
        return;
      }

      const rect = block.getBoundingClientRect();
      const relativeCenter = rect.top + rect.height / 2 - viewportHeight / 2;
      const speed = parseFloat(block.dataset.parallaxSpeed || defaultSpeed);
      const limit = parseFloat(block.dataset.parallaxLimit || defaultLimit);
      const scale = parseFloat(block.dataset.parallaxScale || defaultScale);
      const shift = Math.max(-limit, Math.min(limit, -relativeCenter * speed));

      target.style.transform = `translate3d(0, ${shift}px, 0) scale(${scale})`;
    });

    ticking = false;
  };

  const resetTransforms = () => {
    mediaBlocks.forEach((block) => {
      const targetSelector = block.dataset.parallaxTarget || defaultTarget;
      const target =
        targetSelector === 'self' ? block : block.querySelector(targetSelector) || block.querySelector('img');
      if (!target) {
        return;
      }
      const scale = parseFloat(block.dataset.parallaxScale || defaultScale);
      target.style.transform = `scale(${scale})`;
    });
  };

  const requestTick = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  const handleScroll = () => {
    if (!enabled) {
      return;
    }
    requestTick();
  };

  const handleResize = () => {
    const shouldEnable = window.innerWidth >= minWidth;
    if (shouldEnable !== enabled) {
      enabled = shouldEnable;
      if (!enabled) {
        resetTransforms();
      } else {
        requestTick();
      }
    } else if (enabled) {
      requestTick();
    }
  };

  handleResize();
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize);
};

const initLoyaltyButton = () => {
  ensureLoyaltyButton();
  document.querySelectorAll('.dialog-widget .eael-simple-menu').forEach(ensureLoyaltyButtonForMenu);

  if (loyaltyObserver) {
    return;
  }

  const headerRoot = document.querySelector('.elementor-location-header');

  loyaltyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
          return;
        }

        if (node.matches('.dialog-widget') || node.querySelector('.dialog-widget')) {
          node.querySelectorAll('.eael-simple-menu').forEach(ensureLoyaltyButtonForMenu);
        }
      });
    });

    ensureLoyaltyButton();
  });

  loyaltyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  if (headerRoot) {
    loyaltyObserver.observe(headerRoot, {
      childList: true,
      subtree: true,
    });
  }
};

// Пробуем инициализировать sticky header как можно раньше
initStickyHeader();
ensureLoyaltyButton();

// Place for custom theme scripts
document.addEventListener('DOMContentLoaded', () => {
  // Выполняем повторно при DOMContentLoaded
  fixOverflowForStickyTemplate();

  // Инициализируем липкий хедер
  initStickyHeader();
  initLoyaltyButton();

  // Room slider functionality
  const room = document.querySelector('.room');
  if (!room) return;

  const mainEl = room.querySelector('.room__slider');
  const nextEl = room.querySelector('.swiper-button-next2');
  const prevEl = room.querySelector('.swiper-button-prev2');

  const thumbs = Array.from(room.querySelectorAll('.room__thumb'));
  const thumbsWrap = room.querySelector('.room__thumbs');
  const setActiveThumb = (index) => {
    thumbs.forEach((t, i) => t.classList.toggle('room__thumb--active', i === index));
  };

  const ensureSwiper = () => {
    if (!mainEl) return null;
    // If Swiper is already initialized elsewhere (e.g. footer scripts), reuse it
    if (mainEl.classList.contains('swiper-initialized') && mainEl.swiper) {
      return mainEl.swiper;
    }
    if (typeof Swiper !== 'undefined') {
      return new Swiper(mainEl, {
        loop: false,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
      });
    }
    return null;
  };

  const init = () => {
    const swiper = ensureSwiper();
    if (!swiper) return;
    const activeIndex = swiper.realIndex || swiper.activeIndex || 0;
    setActiveThumb(activeIndex);
    // ensure first three visible
    if (thumbsWrap) {
      const itemWidth = thumbs[0] ? thumbs[0].getBoundingClientRect().width : 0;
      thumbsWrap.scrollLeft = Math.max(0, (activeIndex - 0) * (itemWidth + 12));
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof swiper.slideTo === 'function') {
          swiper.slideTo(index);
        }
        setActiveThumb(index);
        if (thumbsWrap) {
          const itemWidth = thumb.getBoundingClientRect().width;
          // показываем группу по 3: 0-2, 3-5, ...
          const groupIndex = Math.floor(index / 3);
          thumbsWrap.scrollLeft = groupIndex * (itemWidth * 3 + 24);
        }
      });
    });
    swiper.on('slideChange', () => {
      const idx = swiper.realIndex || swiper.activeIndex || 0;
      setActiveThumb(idx);
      if (thumbsWrap) {
        const itemWidth = thumbs[0] ? thumbs[0].getBoundingClientRect().width : 0;
        const groupIndex = Math.floor(idx / 3);
        thumbsWrap.scrollLeft = groupIndex * (itemWidth * 3 + 24);
      }
    });
  };

  // Wait for window load so that footer scripts (if any) can initialize Swiper first
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
});

// Инициализируем липкий хедер после полной загрузки страницы (в т.ч. после Elementor)
window.addEventListener('load', () => {
  console.log('Window loaded, initializing sticky header...');
  initStickyHeader();
  initLoyaltyButton();
  
  // Инициализируем слайдер loyalty-types после полной загрузки (когда Swiper точно доступен)
  initLoyaltyTypesSlider();
});

// Если Elementor загружается динамически, слушаем его события
document.addEventListener('elementor/frontend/init', () => {
  console.log('Elementor frontend initialized, initializing sticky header...');
  setTimeout(() => {
    initStickyHeader();
    initLoyaltyButton();
  }, 100);
});

// Инициализация слайдера для loyalty-types на мобильных устройствах
const initLoyaltyTypesSlider = () => {
  const gridElement = document.querySelector('.loyalty-types-swiper');
  if (!gridElement || typeof Swiper === 'undefined') {
    return;
  }

  const isMobile = window.innerWidth <= 768;
  let swiperInstance = gridElement.swiper;

  if (isMobile && !swiperInstance) {
    // Инициализируем слайдер на мобильных
    swiperInstance = new Swiper('.loyalty-types-swiper', {
      slidesPerView: 1.2,
      spaceBetween: 24,
      loop: false,
      freeMode: true,
      grabCursor: true,
      navigation: {
        nextEl: '.loyalty-types-nav-next',
        prevEl: '.loyalty-types-nav-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
      },
    });
  } else if (!isMobile && swiperInstance) {
    // Уничтожаем слайдер на десктопе
    swiperInstance.destroy(true, true);
    gridElement.swiper = null;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const goldCard = document.querySelector('.loyalty-points__illustration_gold');
  const silverCard = document.querySelector('.loyalty-points__illustration_silver');
  initLoyaltyParallax('.loyalty-standard__media', { defaultSpeed: 0.18, defaultLimit: 140, defaultScale: 1.08 });
  initLoyaltyParallax('.loyalty-rules__media', { defaultSpeed: 0.12, defaultLimit: 200, defaultScale: 1.02 });

  // Обработка изменения размера окна для слайдера
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initLoyaltyTypesSlider, 250);
  });

  if (!goldCard && !silverCard) {
    return;
  }

  const tiltStrength = 50;
  document.addEventListener('mousemove', (e) => {
    const relativeX = e.clientX / window.innerWidth - 0.5;
    const relativeY = e.clientY / window.innerHeight - 0.5;

    const rotateX = relativeY * tiltStrength;
    const rotateY = -relativeX * tiltStrength;

    if (goldCard) {
      goldCard.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    }
    if (silverCard) {
      silverCard.style.transform = `rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
    }
  });

  // Не сбрасываем наклон при уходе курсора — оставляем последнее положение.
});

// Попап с формой для страницы лояльности
const initLoyaltyPopup = () => {
  const popup = document.getElementById('loyalty-popup');
  if (!popup) {
    return;
  }

  const overlay = popup.querySelector('.loyalty-popup__overlay');
  const closeBtn = popup.querySelector('.loyalty-popup__close');
  const formWrapper = popup.querySelector('.loyalty-popup__form-wrapper');
  const popupTitle = popup.querySelector('.loyalty-popup__title');
  const triggers = document.querySelectorAll('.loyalty-popup-trigger');

  let currentFormShortcode = '';

  const openPopup = (formShortcode, title = '') => {
    currentFormShortcode = formShortcode;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('loyalty-popup--active');
    document.body.style.overflow = 'hidden';
    
    // Устанавливаем заголовок попапа
    if (popupTitle) {
      popupTitle.textContent = title;
      popupTitle.style.display = title ? 'block' : 'none';
    }
    
    // Загружаем форму через AJAX только если shortcode указан
    if (formShortcode && formShortcode.trim() !== '') {
      loadForm(formShortcode.trim());
    }
  };

  const closePopup = () => {
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('loyalty-popup--active');
    document.body.style.overflow = '';
    formWrapper.innerHTML = '';
    currentFormShortcode = '';
    if (popupTitle) {
      popupTitle.textContent = '';
    }
  };

  const loadForm = (shortcode) => {
    formWrapper.innerHTML = '<div class="loyalty-popup__loading">Загрузка формы...</div>';
    
    // Получаем ajaxurl из глобальной переменной или используем стандартный путь
    const ajaxUrl = typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp-admin/admin-ajax.php';
    
    // Отправляем AJAX запрос для получения формы
    const formData = new URLSearchParams({
      action: 'loyalty_load_cf7_form',
      shortcode: shortcode,
    });
    
    fetch(ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
      credentials: 'same-origin',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.success && data.data && data.data.html) {
          const html = data.data.html;
          
          // Проверяем, есть ли ошибка в HTML
          if (html.includes('Ошибка:') || html.includes('не найдена')) {
            formWrapper.innerHTML = '<div class="loyalty-popup__error">Форма не найдена. Проверьте правильность shortcode в настройках страницы. Убедитесь, что форма Contact Form 7 существует и ID указан правильно.</div>';
            return;
          }
          
          formWrapper.innerHTML = html;
          
          // Инициализируем CF7 форму вручную (только один раз!)
          setTimeout(() => {
            const form = formWrapper.querySelector('form.wpcf7-form');
            
            if (form && form.tagName === 'FORM') {
              // Проверяем, не была ли форма уже инициализирована
              if (form.dataset.popupInitialized === 'true') {
                return;
              }
              form.dataset.popupInitialized = 'true';
              
              form.classList.add('loyalty-popup-form');
              
              // Функция обновления reCAPTCHA токена
              const refreshRecaptcha = () => {
                const recaptchaField = form.querySelector('input[name="_wpcf7_recaptcha_response"]');
                if (recaptchaField && typeof grecaptcha !== 'undefined' && typeof wpcf7_recaptcha !== 'undefined') {
                  try {
                    grecaptcha.ready(function() {
                      grecaptcha.execute(wpcf7_recaptcha.sitekey, { action: 'contactform' }).then(function(token) {
                        recaptchaField.value = token;
                      });
                    });
                  } catch (e) {
                    console.log('reCAPTCHA refresh error:', e);
                  }
                }
              };
              
              // Обновляем токен при загрузке формы
              refreshRecaptcha();
              
              // Обновляем токен перед каждой отправкой
              form.addEventListener('submit', () => {
                refreshRecaptcha();
              }, true);
              
              // CF7 5.8 - инициализируем форму
              if (typeof wpcf7 !== 'undefined' && typeof wpcf7.init === 'function') {
                try {
                  wpcf7.init(form);
                } catch (e) {
                  console.error('CF7 init error:', e);
                }
              }
              
              // Обработка успешной отправки
              form.addEventListener('wpcf7mailsent', () => {
                setTimeout(() => {
                  closePopup();
                }, 2000);
              }, { once: true });
            }
          }, 100);
        } else {
          const errorMsg = data.data && data.data.message ? data.data.message : 'Ошибка загрузки формы. Попробуйте позже.';
          formWrapper.innerHTML = `<div class="loyalty-popup__error">${errorMsg}</div>`;
        }
      })
      .catch(error => {
        formWrapper.innerHTML = '<div class="loyalty-popup__error">Ошибка загрузки формы. Попробуйте позже.</div>';
      });
  };

  // Обработчики открытия попапа
  triggers.forEach(trigger => {
    let isProcessing = false;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Предотвращаем двойной клик
      if (isProcessing) {
        return;
      }
      
      isProcessing = true;
      setTimeout(() => { isProcessing = false; }, 1000);
      
      const formShortcode = trigger.getAttribute('data-form-shortcode');
      const buttonTitle = trigger.getAttribute('data-popup-title') || trigger.textContent.trim();
      
      if (formShortcode && formShortcode.trim() !== '') {
        openPopup(formShortcode.trim(), buttonTitle);
      } else {
        openPopup('', buttonTitle);
        formWrapper.innerHTML = '<div class="loyalty-popup__error">Shortcode формы не указан. Пожалуйста, укажите shortcode формы в настройках страницы.</div>';
      }
    });
  });

  // Закрытие по клику на overlay
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  // Закрытие по клику на кнопку закрытия
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  // Закрытие по Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });
};

// Инициализация попапа при загрузке DOM (только один раз!)
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('loyalty-popup');
  if (popup && !popup.dataset.initialized) {
    popup.dataset.initialized = 'true';
    initLoyaltyPopup();
  }

  // Открытие ссылок в карточках "Как накопить/потратить баллы" в новой вкладке
  const earnCards = document.querySelectorAll('.loyalty-earn__card-content a');
  earnCards.forEach(link => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  initNeighborsMap();
});